import React, {memo} from "react";

const Circle = () => {
  return <span className="block w-[6px] h-[6px] rounded bg-green-600" />;
};

export default memo(Circle);
